import { gql } from '@apollo/client';


export const REMOVE_AXLE_GROUP_FROM_SIZE_AND_WEIGHT = gql`
mutation removeAxleGroupFromSizeAndWeight($input: RemoveAxleGroupFromSizeAndWeightInput!) {
  removeAxleGroupFromSizeAndWeight(input: $input) {
    clientMutationId
    errors
    
  }
}
`